<template>
  <Technicals :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '数据可视化与场景化',
      content: '<div style="font-size:16px;text-indent:2em;">数据可视化系统可以帮助用户通过认知数据，有新的发现，发现这些数据所反映的实质。将视觉结构进行组合，把它转换成图形传递给用户，用户通过人机交互的方式进行反向转换，去更好地了解数据背后有什么问题和规律<br /><br /></div><br /><div style="font-size:16px;text-indent:2em;">数据可视化与场景化开发步骤：<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp1)数据空间。由n维属性、m个元素共同组成的数据集构成的多维信息空间。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp2)数据开发。利用一定的工具及算法对数据进行定量推演及计算。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp3)数据分析。对多维数据进行切片、块、旋转等动作剖析数据，从而可以多角度多侧面的观察数据。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp4)数据可视化。将大型数据集中的数据通过图形图像方式表示，并利用数据分析和开发工具发现其中未知信息。<br /><div style="text-indent:2em;">结合数据实时渲染技术、GIS空间数据可视化技术，实现数据实时图形可视化、场景化以及实时交互，让使用者更加方便地进行数据的理解和空间知识的呈现，可应用于指挥监控、视景仿真及三维交互等众多领域。</div></div><img src="../technical/5bab297bc6642.jpg" style="width:700px;height:300px;margin:10px 30px;">'
    }
  }
}
</script>
